import { render } from "./CardChallengeRequestsRivalNumber.vue?vue&type=template&id=6e056602&scoped=true"
import script from "./CardChallengeRequestsRivalNumber.vue?vue&type=script&lang=js"
export * from "./CardChallengeRequestsRivalNumber.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-requests-rival-number.css?vue&type=style&index=0&id=6e056602&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e056602"]])

export default __exports__